module.exports = __webpack_public_path__ + "static/media/magnifier.8f96dddd.png";